import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaFileInvoiceDollar,
  FaChartLine,
  FaBoxes,
  FaCog,
  FaArrowRight
} from 'react-icons/fa';
import './Home.css';

const SECTIONS = [
  {
    id: 'billing',
    title: 'Billing',
    description: 'Invoices, proforma bills, measure sheets, and quotations.',
    icon: FaFileInvoiceDollar,
    status: 'active',
    path: '/bills',
    highlights: ['Invoice', 'Proforma', 'Quotations']
  },
  {
    id: 'financials',
    title: 'Financials',
    description: 'Track client ledgers, income, expenses, balances, and financial records.',
    icon: FaChartLine,
    status: 'active',
    path: '/financials',
    highlights: ['Reports', 'Client Reports', 'Income']
  },
  {
    id: 'inventory',
    title: 'Inventory',
    description: 'Manage materials, stock levels, purchases, and site-wise inventory.',
    icon: FaBoxes,
    status: 'coming-soon',
    highlights: ['Stock', 'Materials', 'Purchases']
  },
  {
    id: 'admin',
    title: 'Admin',
    description: 'Company details, clients, preferences, and account management.',
    icon: FaCog,
    status: 'active',
    path: '/admin',
    highlights: ['Companies', 'Clients', 'Projects', 'Vendors']
  }
];

function Home() {
  const navigate = useNavigate();

  const handleSectionClick = (section) => {
    if (section.status === 'active' && section.path) {
      navigate(section.path);
    }
  };

  return (
    <div className="home-dashboard">
      <header className="home-dashboard-header">
        <div>
          <p className="home-dashboard-eyebrow">Workspace</p>
          <h1>Shivam Buildcare</h1>
          <p className="home-dashboard-subtitle">
            Choose a section to get started
          </p>
        </div>
      </header>

      <div className="home-section-grid">
        {SECTIONS.map((section) => {
          const Icon = section.icon;
          const isActive = section.status === 'active';

          return (
            <article
              key={section.id}
              className={`home-section-card${isActive ? ' is-active' : ' is-coming-soon'}`}
              onClick={() => handleSectionClick(section)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleSectionClick(section);
                }
              }}
              role={isActive ? 'button' : 'article'}
              tabIndex={isActive ? 0 : -1}
              aria-disabled={!isActive}
            >
              <div className="home-section-card-top">
                <span className="home-section-icon" aria-hidden="true">
                  <Icon />
                </span>
                <span className={`home-section-badge${isActive ? ' active' : ''}`}>
                  {isActive ? 'Available' : 'Coming soon'}
                </span>
              </div>

              <div className="home-section-card-body">
                <h2>{section.title}</h2>
                <p>{section.description}</p>

                <ul className="home-section-highlights">
                  {section.highlights.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>

              <div className="home-section-card-foot">
                {isActive ? (
                  <>
                    <span>Open section</span>
                    <FaArrowRight aria-hidden="true" />
                  </>
                ) : (
                  <span>In development</span>
                )}
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
}

export default Home;
